// extracted by css-extract-rspack-plugin
export default {"footer":"Footer-module__footer__kjBR4","spacer":"Footer-module__spacer__DUfjP","footerItem":"Footer-module__footerItem__vOtdV"};